<template>
	<div>
		<el-dialog
			:visible.sync="show"
			width="40%"
			:before-close="handleClose">

			<div class="titleImg">
				<img src="../../assets/imgs/RemoteSensingMall/sthzhb.png" alt="">
			</div>

			<div v-for="(item,index) in shoplist" :key="index">
				<div class="title"><span>{{ item.title }}</span></div>
				<ul>
					<li v-for="(shop,i) in item.list" :key="i" style="width: 50%">{{ shop }}</li>
				</ul>
			</div>

			<span slot="footer" class="dialog-footer">
  </span>
		</el-dialog>
	</div>
</template>

<script>
export default {
  name: "ShowShopList",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shoplist: [
        {
          title: '供应商',
          list: [
            '航天宏图信息技术股份有限公司',
            '长光卫星技术股份有限公司',
            '珠海欧比特宇航科技股份有限公司',
            '二十一世纪空间技术应用股份有限公司',
            '天仪空间科技研究院有限公司',
            '山东产研卫星信息技术产业研究院有限公司',
            '微纳星空科技有限公司',
            '银河航天科技有限公司',
            '中科星图股份有限公司',
            '航天信德智图（北京）科技有限公司',
            '北京科思腾达科技有限公司',
            '北京天链测控技术有限公司',
            '北京航天驭星科技有限公司'
          ]
        },
        {
          title: '需求商',
          list: [
            '北京英视睿达科技股份有限公司',
            '中国铁路设计集团有限公司',
            '四川省国防科技情报研究所',
            '海关总署缉私局',
            '中华联合财产保险股份有限公司',
            '中国人寿财产保险股份有限公司',
            '中国太平洋财产保险股份有限公司'
          ]
        },
        {
          title: '国际合作伙伴',
          list: [
            '国家航天局卫星数据与应用国际合作中心',
            '国家航天局对地观测与数据中心',
            '北京和德宇航技术有限公司',
            '中国长城工业集团有限公司',
            '中国华腾工业有限公司',
            '中国资源卫星应用中心',
            '国家卫星气象中心',
            '国家卫星海洋应用中心'
          ]
        },
        {
          title: '基础共建单位',
          list: [
            '国家航天局对地观测与数据中心',
            '中国资源卫星应用中心',
            '国家卫星气象中心',
            '国家卫星海洋应用中心',
            '中国科学院空天信息创新研究院',
            '中国电子科技集团公司第五十四研究所',
            '浙江大学'
          ]
        }
      ]
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('close')
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    }
  }
}
</script>

<style scoped lang="scss">
.titleImg {
	width: 300px;
	margin: 0 auto;
	img {
		width: 100%;
		height: 100%;
	}
}

.title {
  text-align: center;
  margin: 20px 0;

	font-size: 18px;
	color: #2569F2;
}

.title span {
	position: relative;
}

.title span::before {
	display: block;
	content: '';
	width: 5px;
	height: 5px;
	background: #9BBEFF;
	position: absolute;
	top: 10px;
	left: -15px;
	transform: rotate(45deg);
}

.title span::after {
	display: block;
	content: '';
	width: 5px;
	height: 5px;
	background: #9BBEFF;
	position: absolute;
	top: 10px;
	left: 110%;
	transform: rotate(45deg);
}

ul {
  display: flex;
  flex-wrap: wrap;
	background: #ECEFF5;
	padding: 18px;
	border-radius: 10px;
}
li {
	padding: 15px 0;
	border-bottom: 1px dashed #d9dadc;
	color: #333333;
	font-size: 16px;
}
</style>
